import { render, staticRenderFns } from "./MakeAppointmentForm.vue?vue&type=template&id=10193dc7&"
import script from "./MakeAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./MakeAppointmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports